module.exports = __webpack_public_path__ + "static/media/settings.bdde62ce.svg";